import { useEffect, useState, useContext } from "react";
import ProjectBlob from "./ProjectBlob";
import { userContext } from '../../contexts/userContext';
import serverURL from "../../config/serverConfig";
import { ChartNoAxesGantt, FilePlus, Loader, Disc3 } from 'lucide-react';
import { Link } from "react-router-dom";


    export const ProjectsWidget = (props) => {

        const user_id = useContext(userContext);
        //console.log(props.projects)

        const [activeProjects, setActiveProjects] = useState([]); // List of active projects
        let projectList = props.projects; // Temporary storage for project data
        const [selectedSort, setSelectedSort] = useState("dateAsc");

        const sortProjects = (projects, sortType) => {
            switch (sortType) {
                case "dateAsc":
                    projects.sort((a, b) => new Date(a.due_date) - new Date(b.due_date)); // sort by due date
                    return projects;
                case "dateDesc":
                    projects.sort((a, b) => new Date(b.due_date) - new Date(a.due_date)); // sort by due date descending
                    return projects;
                case "clientAsc":
                    projects.sort((a, b) => a.client.localeCompare(b.client)); // sort by client name ascending
                    return projects;
                case "clientDesc":  
                    projects.sort((a, b) => b.client.localeCompare(a.client)); // sort by client name descending
                    return projects;
                case "statusAsc":
                    projects.sort((a, b) => b.status.localeCompare(a.status)); // sort by status ascending
                    return projects;
                case "statusDesc":
                    projects.sort((a, b) => a.status.localeCompare(b.status)); // sort by status descending
                    return projects;
                default:
                    return projects; // No sorting
            }
        };

        useEffect(() => {
                if (projectList){

                let sortedProjects = sortProjects(projectList, selectedSort);

                const loadedProjects = sortedProjects
                .filter(project => project.status != "Complete")
                .map(project => (
                    <Link
                        to="project"
                        state={{ project_id: project.project_id }}
                        key={project.project_id}
                        className="blobLink hoverLeft w-[98%]"
                    >
                        <ProjectBlob project={project} />
                    </Link>
                ));

                setActiveProjects(loadedProjects);
            }
        }, [projectList, selectedSort]);
        

        return (
                <div id="projectWidget" className="h-full">
                    <div id="projectListTop" className="flex justify-between"> 
                        <h3 className="flex p-0 gap-1 items-center"><Disc3 color="#ffee00" size={16}/>ACTIVE PROJECTS</h3>
                        {/* <Link to="createproject" id="newProjectLink"><span className="tooltip"><FilePlus /><div className="tooltiptext">+ create new project</div></span></Link> */}
                        <div id="sortOptions" className="grid grid-cols-3 uppercase font-semibold text-[9px] items-end align-center">
                            <div className={selectedSort.includes("client") ? "text-[#ffee00] min-w-[20px] flex justify-center" : "width-[21px] flex justify-center"}>
                                <span onClick={() => setSelectedSort(selectedSort==="clientAsc" ? "clientDesc" : "clientAsc")} className="cursor-pointer">
                                    Client
                                </span>
                                <span className="w-[10px] overflow-hidden">
                                    {selectedSort === "clientAsc" ? "↓" : selectedSort === "clientDesc" ? "↑" : '\u00A0'}
                                </span>
                            </div>
                            <div className={selectedSort.includes("date") ? "text-[#ffee00] flex justify-center" : "flex justify-center"}>
                                <span onClick={() => setSelectedSort(selectedSort==="dateAsc" ? "dateDesc" : "dateAsc")} className="cursor-pointer">
                                    Due
                                </span>
                                <span className="w-[10px] overflow-hidden">
                                    {selectedSort === "dateAsc" ? "↓" : selectedSort === "dateDesc" ? "↑" : "\u00A0"}
                                </span>
                            </div>
                            <div className={selectedSort.includes("status") ? "text-[#ffee00] flex justify-center" : "flex justify-center"}>
                                <span onClick={() => setSelectedSort(selectedSort==="statusAsc" ? "statusDesc" : "statusAsc")} className="cursor-pointer">
                                    Status
                                </span>
                                <span className="w-[10px] overflow-hidden">
                                    {selectedSort === "statusAsc" ? "↓" : selectedSort === "statusDesc" ? "↑" : "\u00A0"}
                                </span>
                            </div>
                            
                        </div>
                    </div>
                    <div className="hBar mt-[7px] mb-[10px]"></div>
                    <div id="projectList" className="flex">
                        {projectList?
                            <div id="blobList" className="max-h-[450px] flex flex-col items-center gap-1">
                                {activeProjects}
                            </div>
                        :
                            <Loader className="spinning"/>
                        }
                    </div>
                </div>
        )
    }

